// extracted by mini-css-extract-plugin
var _1 = "ConfigSnippetPanel_actions__KJB-K";
var _2 = "ConfigSnippetPanel_copyButton__hvcmJ";
var _3 = "ConfigSnippetPanel_intro__XGsI-";
var _4 = "ConfigSnippetPanel_panel__pVeN7";
var _5 = "ConfigSnippetPanel_snippet__xFS3M";
var _6 = "ConfigSnippetPanel_tab__mbL4P";
var _7 = "ConfigSnippetPanel_tabActive__PsLA7";
var _8 = "ConfigSnippetPanel_tabs__GG1zN";
var _9 = "ConfigSnippetPanel_urlNote__Yfuvm";
export { _1 as "actions", _2 as "copyButton", _3 as "intro", _4 as "panel", _5 as "snippet", _6 as "tab", _7 as "tabActive", _8 as "tabs", _9 as "urlNote" }
